// import systemFileList from '../components/systemFile/systemFileList.vue'

export default [
    { 
        path: 'systemFile/systemFileList',
        component: resolve => require(['@/components/systemFile/systemFileList'],resolve),
        name:'SystemFileList',
        meta:{
            id:'926',
            node:'systemFile',
            url:'systemFileList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/systemFile.js